import {
    BlockerConfig, AjaxStdResponse, BsModal, Blocker,
    Support,
    DateTimePicker
} from './TS_Controls'


import * as moment from '../node_modules/moment/moment'



interface ClassesConfig {
    Panel?: string;
    ModalPanel?: string;
    Endpoint?: string;
    InsertPanel?: string;
    BlockerConfig?: BlockerConfig;
}




interface SUPER_ITEM {
    Class?: ClassDTO;
    ClassName?: string;
    InstructorName?: string;
    LocationName?: string;

    Schedules?: NameValueDTO[];
    NewSched?: SUPER_ScheduleDTO;

    Excludes?: NameValueDTO[];
    NewExclude?: ExcludeDTO;

    StartDateFormat?: KnockoutComputed<string>;
    EndDateFormat?: KnockoutComputed<string>;
}


class ClassDTO {
    RecordID?: number = 0;
    InstructorID?: number = 0;
    LocationID?: number = 0;
    ClassTypeID?: number = 0;
    StartDate?: string = null;
    EndDate?: string = null;
}



export interface NameValueDTO {
    N?: string;
    V?: number;
}



interface ClassSchedulesDTO {
    ClassID?: number;
    Schedules?: NameValueDTO[]
}


interface ClassExcludesDTO {
    ClassID?: number;
    Excludes?: NameValueDTO[]
}





interface ClassResponse extends AjaxStdResponse {

    Item: ClassDTO;
    Items: ClassDTO[];

    ClassTypes: NameValueDTO[]
    Instructors: NameValueDTO[]
    Locations: NameValueDTO[]

    Schedules: ClassSchedulesDTO[]
    Excludes: ClassExcludesDTO[]
}




interface ScheduleResponse extends AjaxStdResponse {
    Schedule?: ClassSchedulesDTO
}


interface ExcludeResponse extends AjaxStdResponse {
    Exclude?: ClassExcludesDTO
}



interface ScheduleDTO {
    ClassID?: number;
    Sun?: boolean;
    Mon?: boolean;
    Tue?: boolean;
    Wed?: boolean;
    Thu?: boolean;
    Fri?: boolean;
    Sat?: boolean;
    Start?: number;
    StartMinute?: number;
    End?: number;
    EndMinute?: number;
}


interface SUPER_ScheduleDTO extends ScheduleDTO {
    StartString?: string;
    EndString?: string;
}




class ExcludeDTO {
    ClassID?: number = 0;
    Date?: string = null;
}




class ClassFilterDTO {
    InstructorID?: number = 0;
    ClassTypeID?: number = 0;
    LocationID?: number = 0;
    // LocationName?: string = null;
}






export class AdminClasses {

    private _cfg: ClassesConfig;
    private _mdl: BsModal;
    private _blk: Blocker;

    // private _emptyItem: NameValueDTO;

    public Items: KnockoutObservableArray<SUPER_ITEM>;

    public ClassTypes: KnockoutObservableArray<KnockoutObservableType<NameValueDTO>>;
    public Instructors: KnockoutObservableArray<KnockoutObservableType<NameValueDTO>>;
    public Locations: KnockoutObservableArray<KnockoutObservableType<NameValueDTO>>;
    // public ClassDays: KnockoutObservableArray<KnockoutObservableType<ClassDayDTO>>;

    // public NewItem: KnockoutObservableType<ClassItem>;
    public NewClass: KnockoutObservableType<ClassDTO>;
    // public NewClassTypeID: KnockoutObservable<number>;
    // public NewInstructorID: KnockoutObservable<number>;

    public Hours: KnockoutObservableArray<string>;
    public Minutes: KnockoutObservableArray<string>;


    public FilterObj: KnockoutObservableType<ClassFilterDTO>;


    private _realm = "classes";

    constructor(config: ClassesConfig) {

        this._cfg = config;
        this._mdl = new BsModal({
            Panel: config.ModalPanel,
        });
        this._blk = new Blocker(config.BlockerConfig);
        this.Setup();
    }


    private _copy: ClassDTO;
    public ShowEdit(item: KnockoutObservableType<SUPER_ITEM>,
        evt: Event): void {



        var obs = item.Class as KnockoutObservableType<ClassDTO>;

        /// CRATING A COPY OF OUR OBJECT.
        /// 
        this._copy = ko.mapping.toJS(item.Class) as any;

        /*
        OK LET'S FIND OUR EDIT PANEL NEARBY TO THE EDIT BUTTON.
        FIRST LOOK FOR THE CONTAINER PANEL, THEN FOR THE EDIT PANEL
        CONTAINED IN IT.
        */
        let $pnlEdit = $(evt.target).closest('[data-item="panel-item"]')
            .find('[data-item="panel-edit"]');

        this._mdl.Display({
            Title: "Edit Class",
            DomObj: $pnlEdit,
            Buttons: [
                {
                    Text: 'Update Class',
                    Class: 'btn btn-primary',
                    Callback: (evt) => {
                        this.Editing(obs);
                    },
                },
                {
                    Text: 'Cancel',
                    Class: 'btn btn-default',
                    Callback: (evt) => this.CancelEdit(obs),
                },
            ],
            OnVisibility: (viz: boolean) => {
                if (viz) {
                    $pnlEdit.removeClass("as-hidden");
                } else {
                    $pnlEdit.addClass("as-hidden");
                }
            }
        });

    }



    public Editing(currItem: KnockoutObservableType<ClassDTO>): void {
        console.log("Class edited: ", currItem);

        this._blk.Block();

        var i: ClassDTO = ko.mapping.toJS<ClassDTO>(currItem);

        Support.Post<ClassResponse>(
            this._cfg.Endpoint + "?action=edit&realm=" + this._realm,
            i
            ,
        ).then((accept) => {

            this.Edited(currItem, accept.Item);
            // console.log("SAVED!", accept);

        })
            .catch((errr) => this.PostError(errr))
            .then(() => {
                /*
                 UNBLOCK THE SCREEN. 
                 THIS IS LIKE A FINALLY BLOCK
                 */
                this._blk.Unblock();
            });
    }



    private Edited(currItem: KnockoutObservableType<ClassDTO>,
        item: ClassDTO): void {
        /// MAPPING THE RESULTING OBJECT ONTO THE ORIGINAL OBJECT.
        /// 
        this.Items().forEach((i) => {
            if (i.Class == currItem as any) {

                ko.mapping.fromJS(currItem, i.Class);

                let cname: string = this.GetClassName(currItem.ClassTypeID());
                let iname: string = this.GetInstructorName(currItem.InstructorID());
                let lname: string = this.GetLocationName(currItem.LocationID());

                (i.ClassName as any)(cname);
                (i.InstructorName as any)(iname);
                (i.LocationName as any)(lname);
            }
        });

    }





    private CancelEdit(item: KnockoutObservableType<ClassDTO>): void {

        /// RESTORE OUR BACKED UP ITEM.
        item = ko.mapping.fromJS(this._copy, {}, item);

    }



    private _deleting: KnockoutObservableType<SUPER_ITEM>;
    public Delete(sender: KnockoutObservableType<SUPER_ITEM>): void {

        this._deleting = sender;

        var theClass: ClassDTO = ko.mapping.toJS(sender.Class) as ClassDTO;

        this._mdl.Confirm(
            `Are you sure you want to Delete Class
                <strong>${ sender.ClassName()}</strong> with 
                Instructor <strong>${ sender.InstructorName()}</strong>`,
            (result: boolean) => {

                if (result) {
                    this.Deleting(theClass);
                }
            },
            "Confirm Delete of Instructor"
        );
    }



    private Deleting(theClass: ClassDTO): void {

        this._blk.Block();

        Support.Post<ClassResponse>(
            this._cfg.Endpoint + "?action=delete&realm=" + this._realm,
            theClass
            ,
        ).then((accept) => {

            this.Deleted();

        })
            .catch((errr) => this.PostError(errr))
            .then(() => {
                /*
                 UNBLOCK THE SCREEN. 
                 THIS IS LIKE A FINALLY BLOCK
                 */
                this._blk.Unblock();
            });
    }



    private Deleted(): void {

        this.Items.remove(this._deleting as any);
        // return;


        // let iof: number = this.Items.indexOf(sender);
        // this.Items.splice(iof, 1);
    }





    private Load(): void {

        this._blk.Block();

        var filterObj: ClassFilterDTO = ko.mapping.toJS<ClassFilterDTO>(this.FilterObj);

        Support.Post<ClassResponse>(
            this._cfg.Endpoint + "?action=load&realm=" + this._realm,
            filterObj
            ,
        ).then((accept) => {

            this.Loaded(accept);
            // console.log("SAVED!", accept);

        })
            .catch((errr) => this.PostError(errr))
            .then(() => {
                /*
                 UNBLOCK THE SCREEN. 
                 THIS IS LIKE A FINALLY BLOCK
                 */
                this._blk.Unblock();
            });
    }



    public DayChanged(dayObj: any, evt: Event): void {

        /// BOOSTRAP STORES THE CHECKBOX VALUE ON A PROPERTY.
        ///
        var isChecked = $(evt.target).prop("checked");

        /// PASSING THE CHECKBOX VALUE TO THE OBSERVABLE...
        ///
        dayObj(isChecked);
    }



    private _loaded: boolean = false;
    private Loaded(obj: ClassResponse): void {

        
        /// ENSURING AN EMPTY COLLECTION IF NULL RESULTS
        // if (items == null) items = [];


        if (!this._loaded) {
            this.Instructors = ko.mapping.fromJS(obj.Instructors) as any;
            this.ClassTypes = ko.mapping.fromJS(obj.ClassTypes) as any;
            this.Locations = ko.mapping.fromJS(obj.Locations) as any;


            this.NewClass = ko.mapping.fromJS(new ClassDTO());
            // this.NewClassTypeID = ko.observable(0);
            // this.NewInstructorID = ko.observable(0);
            // this._emptyItem = obj.EmptyNameValueDTO;
        }



        let arrr: SUPER_ITEM[] = [];

        /*
        FOR ANY ITEM RETURNED, WE ARE APPENDING A PROPERTY NewSched
        WITH A ScheduleDTO OBJECT, SO EACH INDIVIDUAL ITEM CAN 
        STORE THERE NEW SCHEDULE INFO FOR INSERTING PURPOSES.
        */
        obj.Items.forEach(i => {


            let newI: SUPER_ITEM = this.GetSuperI(i);


            /// PASSING THE SCHEDULES TO THE SUPER ITEM.
            ///
            obj.Schedules.forEach(s => {
                if (s.ClassID != i.RecordID)
                    return;

                newI.Schedules = s.Schedules;
            });

            obj.Excludes.forEach(s => {
                if (s.ClassID != i.RecordID)
                    return;

                newI.Excludes = s.Excludes;
            });



            arrr.push(newI);


        })


        if (!this._loaded) {

            this.Items = ko.mapping.fromJS(arrr) as any;

            /*
            WE CAN APPLY BINDINGS JUST NOW THAT WE HAVE LOADED 
            ALL OUR NECESSARY OBJECTS.
            */

            ko.applyBindings(this, $(this._cfg.Panel)[0]);


        } else {

            /// REMOVING ALL THE OLD VALUES.
            this.Items.removeAll();

            /*  PUSHING ALL THE NEW ONES !
                USING  ko.utils.arrayPushAll IS CAUSING SOME ISSUES,
                THEREFORE WE'LL PUSH ONE BY ONE, WE ARE ITERATING THE ARRAY,
                CONVERTING EACH OBJECT AND THEN ADDING IT TO THE OBSERVABLE ARRAY.
            */
            arrr.forEach(i => {
                let mapped: any = ko.mapping.fromJS(i);
                this.Items.push(mapped);
            });
            // ko.utils.arrayPushAll(this.Items, arrr);

        }

        this._loaded = true;

        console.log("Loading completed");
    }







    public ShowInsert(): void {

        this._mdl.Display({
            Title: 'Create New Class',
            DomSelector: this._cfg.InsertPanel,
            Buttons: [
                {
                    Text: "Create Class",
                    Class: 'btn btn-primary',
                    Callback: (evt) => this.Inserting(),
                },
                {
                    Text: "Cancel",
                    Class: 'btn btn-default',
                    Callback: (evt) => this.CancelInsert(),
                },
            ],
            OnVisibility: (viz: boolean) => {
                if (viz) {
                    $(this._cfg.InsertPanel).removeClass("as-hidden");
                } else {
                    $(this._cfg.InsertPanel).addClass("as-hidden");
                }
            }
        });
    }



    private PostError(msg: any) {
        this._mdl.Alert(msg, null, "Error :(");
    };



    private Inserting(): void {
        // console.log("Class inserted: %s", this.NewItem());

        this._blk.Block();

        var objInsert: ClassDTO = ko.mapping.toJS(this.NewClass) as any;


        Support.Post<ClassResponse>(
            this._cfg.Endpoint + "?action=insert&realm=" + this._realm,
            objInsert
            ,
        ).then((accept) => {

            this.Inserted(accept);
            // console.log("SAVED!", accept);

        })
            .catch((errr) => this.PostError(errr))
            .then(() => {
                /*
                 UNBLOCK THE SCREEN. 
                 THIS IS LIKE A FINALLY BLOCK
                 */
                this._blk.Unblock();
            });

    }



    private Inserted(response: ClassResponse) {

        var newI: SUPER_ITEM = this.GetSuperI(response.Item);

        let newObj = ko.mapping.fromJS(newI) as any;

        /// PUSH IT TO THE COLLECTION.
        ///
        this.Items.push(newObj);

        /*
        CLEAR THE INSERT FORM
        */
        this.ClearInsertForm();
    }



    private GetClassName(classID: number) {
        return this.Find(this.ClassTypes, classID);
    }


    private GetInstructorName(instrID: number) {
        return this.Find(this.Instructors, instrID);
    }


    private GetLocationName(locID: number) {
        return this.Find(this.Locations, locID);
    }


    private Find(arrrrrr: KnockoutObservableArray<KnockoutObservableType<NameValueDTO>>,
        searchID: number): string {

        let arrr = ko.mapping.toJS(arrrrrr) as any as NameValueDTO[];

        let rval: string;
        arrr.forEach(s => {
            if (s.V != searchID)
                return;

            rval = s.N;
        });

        return rval;
    }


    private GetEmptySched(classID: number): SUPER_ScheduleDTO {
        let rval: SUPER_ScheduleDTO = {
            ClassID: classID,
            Sun: false,
            Mon: false,
            Tue: false,
            Wed: false,
            Thu: false,
            Fri: false,
            Sat: false,
            StartString: '',
            EndString: '',
            Start: 0,
            StartMinute: 0,
            End: 0,
            EndMinute: 0,
        };
        return rval;
    }



    private GetSuperI(item: ClassDTO): SUPER_ITEM {

        var newI: SUPER_ITEM = {
            Class: item,
        };

        newI.ClassName = this.GetClassName(item.ClassTypeID);
        newI.InstructorName = this.GetInstructorName(item.InstructorID);
        newI.LocationName = this.GetLocationName(item.LocationID);


        /// PASSING THE NEW-SCHED OBJECT SO IT CAN COLLECT
        /// NEW SCHEDULE INFORMATION.
        /// 
        newI.NewSched = this.GetEmptySched(item.RecordID);


        /// MAKING SURE WE HAVE A NON EMPTY ARRAY !
        newI.Schedules = [];



        newI.NewExclude = new ExcludeDTO();
        newI.NewExclude.ClassID = item.RecordID;

        newI.Excludes = [];

        return newI;

    }




    private CancelInsert(): void {
        /*
        CLEAR THE INSERT FORM
        */
        this.ClearInsertForm();
    }



    private ClearInsertForm(): void {

        this.NewClass.ClassTypeID(null);
        this.NewClass.InstructorID(null);
        this.NewClass.EndDate(null);
    }





    public Concat(...args: string[]): string {
        var rval = Support.Concat(" ", ...args);
        return rval;
    }



    // public GetClassTypeByID(id: number): any {

    //     var arrrr = this.ClassTypes();

    //     for (var n = 0; n < arrrr.length; n++) {
    //         if (arrrr[n].V() == id)
    //             return arrrr[n].N();
    //     }
    // }



    // public GetInstructorByID(id: number): any {

    //     var arrrr = this.Instructors();

    //     for (var n = 0; n < arrrr.length; n++) {
    //         if (arrrr[n].V() == id)
    //             return arrrr[n].N();
    //     }
    // }


    // public GetClassDays(classID: number): string[] {

    //     var arrrr = this.ClassDays();

    //     for (var n = 0; n < arrrr.length; n++) {
    //         if (arrrr[n].ClassID() == classID)
    //             return arrrr[n].Days();
    //     }
    // }



    private _currItem: KnockoutObservableType<SUPER_ITEM>;
    public SaveSched(obj: KnockoutObservableType<SUPER_ITEM>): void {


        this._currItem = obj;

        var saveSched = ko.mapping.toJS(obj.NewSched);

        this._blk.Block();

        Support.Post<ScheduleResponse>(
            this._cfg.Endpoint + "?action=save-sched&realm=" + this._realm,
            saveSched
            ,
        ).then((accept) => {

            this.SavedSchedule(accept, obj);
            // console.log("SAVED!", accept);

        })
            .catch((errr) => this.PostError(errr))
            .then(() => {
                /*
                 UNBLOCK THE SCREEN. 
                 THIS IS LIKE A FINALLY BLOCK
                 */
                this._blk.Unblock();
            });
    }



    private SavedSchedule(resp: ScheduleResponse,
        obj: KnockoutObservableType<SUPER_ITEM>): void {

        /// MAPPING THE NEW LIST OF DAYS ONTO THE CURRENT 
        /// LIST OF DAYS FOR THE CURRENT CLASS.
        /// 
        // let curr = (this._currItem as any);

        var currScheds = this._currItem.Schedules as KnockoutObservableArray<any>;

        /// EMPTYING THE PREVIOUS ARRAY.
        currScheds.removeAll();
        // curr.ClassDays.removeAll();

        /// LOADING THE OBSERVABLE ARRAY IN THE RIGHT WAY, SO IT CAUSES A 
        /// REBIND. 
        /// 
        ko.utils.arrayPushAll(currScheds, resp.Schedule.Schedules);


        {
            /*
            I'M HAVING A HARD TIME CLEARING THE SCHEDULE DATA.
            I CAN'T ACHIEVE IT VIA KO.MAPPING THEREFORE I'M JUST CLEARING A COUPLE 
            VALUES MANUALLY.
            */

            var ns = (obj.NewSched as KnockoutObservableType<SUPER_ScheduleDTO>);
            ns.StartString("");
            ns.EndString("");


        }
    }





    private _currSched: NameValueDTO;
    private DeleteSched(a: KnockoutObservableType<SUPER_ITEM>,
        s: KnockoutObservableType<NameValueDTO>): void {

        let sched = ko.mapping.toJS(s) as NameValueDTO;

        this._blk.Block();

        Support.Post<ScheduleResponse>(
            this._cfg.Endpoint + "?action=del-sched&realm=" + this._realm,
            sched
            ,
        ).then((accept) => {


            /// REMOVING THE OBSERVABLE ITEM FROM THE ARRAY...
            ///
            (a.Schedules as KnockoutObservableArray<any>)
                .remove(s);

        })
            .catch((errr) => this.PostError(errr))
            .then(() => {
                /*
                 UNBLOCK THE SCREEN. 
                 THIS IS LIKE A FINALLY BLOCK
                 */
                this._blk.Unblock();
            });

    }










    public SaveExclude(obj: KnockoutObservableType<SUPER_ITEM>): void {

        if (!Support.HasContent((obj.NewExclude as KnockoutObservableType<ExcludeDTO>).Date())) {
            this._mdl.Alert("Please specify a Date for excluding");
            return;
        }


        this._currItem = obj;

        let excludeDate = ko.mapping.toJS(obj.NewExclude);


        this._blk.Block();


        Support.Post<ExcludeResponse>(
            this._cfg.Endpoint + "?action=save-exclude&realm=" + this._realm,
            excludeDate
            ,
        ).then((accept) => {

            /*
            CLEARING THE VALUES ON THE SCHEDULE INSERT FORM.
            I KNOW THIS WILL NOT WORK BECAUSE BOOTSTRAP IS
            HACKING THE CHECKBOXES.
 
            MORE OVER, WE HAVE SOME KIND OF STACK OVERFLOW ON THE FOLLOWING.
            REVIEW LATER !
            */
            // var s = new ScheduleDTO();
            // s.ClassID = obj.ClassID;

            // ko.mapping.fromJS(s, obj.NewSched);

            this.SavedExclude(accept);
            // console.log("SAVED!", accept);

        })
            .catch((errr) => this.PostError(errr))
            .then(() => {
                /*
                 UNBLOCK THE SCREEN. 
                 THIS IS LIKE A FINALLY BLOCK
                 */
                this._blk.Unblock();
            });
    }



    private SavedExclude(obj: ExcludeResponse): void {

        /// MAPPING THE NEW LIST OF DAYS ONTO THE CURRENT 
        /// LIST OF DAYS FOR THE CURRENT CLASS.
        /// 
        // let curr = (this._currItem as any);

        var currExcludes = this._currItem.Excludes as KnockoutObservableArray<any>;

        /// EMPTYING THE PREVIOUS ARRAY.
        currExcludes.removeAll();
        // curr.ClassDays.removeAll();

        /// LOADING THE OBSERVABLE ARRAY IN THE RIGHT WAY, SO IT CAUSES A 
        /// REBIND. 
        /// 
        ko.utils.arrayPushAll(currExcludes, obj.Exclude.Excludes);

        /// CLEARING THE DATE ON THE DATE-TIME INSERT COMPONENT.
        ///
        (this._currItem.NewExclude as KnockoutObservableType<ExcludeDTO>)
            .Date(null);

    }





    private DeleteExclude(a: KnockoutObservableType<SUPER_ITEM>,
        s: KnockoutObservableType<NameValueDTO>): void {

        let exclude = ko.mapping.toJS(s) as NameValueDTO;

        this._blk.Block();

        Support.Post<ExcludeResponse>(
            this._cfg.Endpoint + "?action=del-exclude&realm=" + this._realm,
            exclude
            ,
        ).then((accept) => {


            /// REMOVING THE OBSERVABLE ITEM FROM THE ARRAY...
            ///
            (a.Excludes as KnockoutObservableArray<any>)
                .remove(s);

        })
            .catch((errr) => this.PostError(errr))
            .then(() => {
                /*
                 UNBLOCK THE SCREEN. 
                 THIS IS LIKE A FINALLY BLOCK
                 */
                this._blk.Unblock();
            });
    }






    public FormatClassDate(input: string): string {

        let d = new Date(input);

        if (!Support.HasContent(input))
            return "--";

        let rval = moment(d).format("ddd DD, MMM YYYY");

        return rval;
    }













    public FilterChanged(sender: any): void {

        this.Load();
    }


    private Setup(): void {

        let hs: string[] = [];
        let mins: string[] = [];

        for (var n = 0; n <= 23; n++) {
            let val = n.toString();
            if (n < 10) val = "0" + n;
            hs.push(val);
        }

        this.Hours = ko.mapping.fromJS(hs) as any;


        for (var n = 0; n <= 55; n += 5) {
            let val = n.toString();
            if (n < 10) val = "0" + n;
            mins.push(val);
        }

        this.Minutes = ko.mapping.fromJS(mins) as any;


        let fltr = new ClassFilterDTO();
        this.FilterObj = ko.mapping.fromJS(fltr);


        /// ENSURING THERE IS AN EMPTY COLLECTION TO WORK WITH INITIALLY.
        /// 
        this.Load();
    }

}

















ko.bindingHandlers.datetimepicker = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        //initialize datepicker with some optional options

        var format = $(element).data("cal-format");
        var icon = $(element).data("cal-icon");


        var dtp = new DateTimePicker({
            Dom: element,
            Format: format,
            Icon: icon,
            DateChanged: (sender, val) => {

                /// PASSING THE CALENDAR DATE BACK TO THE KNOCKOUT OBSERVABLE.
                if (valueAccessor) {
                    let va = valueAccessor();
                    if (va)
                        va(val);
                }
            },
        });
        dtp.Draw();

        /// STORING THE DATE-TIME-PICKER IN THE DOM OBJECT SO WE CAN REFERENCE IT LATER.
        /// 
        element["dtp"] = dtp;
    },

    update: function (element, valueAccessor) {

        var result = ko.unwrap(valueAccessor());

        /// GETTING THE DATE-TIME-PICKER FROM THE DOM OBJ.
        ///
        let dtp = element["dtp"] as DateTimePicker;

        dtp.SetValue(result);
    }
};












// WEBPACK FOOTER //
// ./js/TS_Classes.ts